<template>
  <b-table
    id="my-team"
    :busy.sync="loading"
    :current-page="currentPage"
    :fields="fields"
    :filter="filter"
    :items="teamMembers"
    :per-page="perPage"
    bordered
    borderless
    class="table-row-text my-team-striped"
    empty-text="There are no site team members."
    fixed
    hover
    primary-key="Id"
    responsive
    show-empty
    stacked="sm"
    striped
    thead-class="thMyTeam"
    @filtered="onFiltered"
  >
    <template #table-busy>
      <div class="text-center text-secondary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template v-slot:head()="data">
      <div class="my-team-table-header">
        {{ data.label }}
      </div>
    </template>
    <template #cell(studyId)="row">
      {{ row.item['studyId'] }} - {{ row.item['siteNumber'] }}
    </template>
    <!-- <template #cell(emails)="row">
      <div v-if="row.item.emails != null && row.item.emails.length > 0">
        {{ row.item.emails.join(', ') }}
      </div>
    </template> -->
    <template #cell(actions)="row">
      <b-button
        v-if="row.item.emails.length > 0"
        class="mr-2 text-primary"
        pill
        variant="light"
        @click="toManageAccess(row.item)"
      >
        <b-icon icon="pencil-fill"></b-icon>
        Manage Access
      </b-button>
    </template>
  </b-table>
</template>

<script>
  export default {
    name: 'TeamMembersTable',
    props: {
      filter: String,
      teamMembers: Array,
      loading: Boolean,
      totalRows: Number,
      perPage: Number,
      currentPage: Number,
    },
    data() {
      return {
        fields: [
          {
            key: 'firstName',
            label: 'First Name',
            sortable: true,
          },
          {
            key: 'lastName',
            label: 'Last Name',
            sortable: true,
          },
          // {
          //   key: 'emails',
          //   label: 'Email',
          // },
          {
            key: 'studyId',
            label: 'Study ID - Site #',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Actions',
          },
        ],
      };
    },
    watch: {
      teamMembers(newValue) {
        this.$emit('update:totalRows', newValue.length);
      },
    },
    methods: {
      toManageAccess(event) {
        let modalMessage = `Would you like to use ${event.studyId}-${event.siteNumber} to manage ${event.firstName} ${event.lastName}'s access?`;
        this.$bvModal
          .msgBoxConfirm(modalMessage, {
            title: `Manage ${event.firstName} ${event.lastName} access`,
            okVariant: 'primary',
            okTitle: `YES (use ${event.studyId}-${event.siteNumber})`,
            cancelTitle: 'NO (select study-site manually)',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            this.$store.commit('setUserDetails', {
              phoneNumber: '',
              firstName: event.firstName,
              lastName: event.lastName,
              emails: event.emails,
              selectedEmail: event.emails[0], //TODO what to do with emails
              personId: event.personId,
            });
            if (value) {
              this.$router.push({
                name: 'application-access-manager-create-request',
                params: {
                  personId: event.personId,
                  studyId: event.studyId,
                  siteId: event.siteNumber,
                },
                query: {
                  userListed: 'true',
                },
              });
            } else if (value === false) {
              this.$router.push({
                name: 'application-access-manager-select-study-site',
                params: { personId: event.personId },
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      onFiltered(filteredItems) {
        this.$emit('update:totalRows', filteredItems.length);
        this.$emit('update:currentPage', 1);
      },
    },
  };
</script>
